import React from 'react'

import style from './styles.module.css'

interface Props {
  value: string
}

const KeyboardTag: React.FC<Props> = ({ value }): JSX.Element => {
  return <span className={style.keyboardTag}>{value}</span>
}

export default KeyboardTag
